(ns app.front.view.application.page-content
  (:require [app.front.ui.rich-text :as ui-rt]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.event :refer [<sub]]))

(defn page-content [{:keys [tr loading? process-target]} & children]
  (let [instructions (<sub [::ws-subs/instructions-text-for-the-phase (:entity/type process-target)])]
    [:div.relative.z-10
     [:div.mb-8.px-8
      (when instructions
        [:div.mt-8
         [ui-rt/editor-legacy {:initial-value instructions
                               :id            (str (:db/id process-target) "-instructions")}]])]
     (if loading?
       [:div.px-8 (tr [:loading])]
       (into [:<>] children))]))
